// Register the PWA service worker on production builds only.
//
// Dev mode skips registration because Vite's HMR conflicts with SW
// caching of /src/* module URLs — easier to just not register a SW
// while iterating, and rely on HMR for live reload.

export function registerServiceWorker() {
  if (import.meta.env.DEV) return;
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;

  // updateViaCache: 'none' tells the browser to bypass HTTP cache when
  // checking sw.js for updates. Without this, browsers may serve a
  // cached sw.js for up to 24h and updates would stall.
  navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' })
    .catch((err) => {
      console.warn('[sw] registration failed:', err);
    });
}
